import _styled from "@emotion/styled/base";
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import PropTypes from 'prop-types';
import { List } from 'immutable';
import { WidgetPreviewContainer } from 'decap-cms-ui-default';

// Media that isn't saved yet is served from a `blob:` URL, which belongs to the
// CMS origin. Opened as a page, an SVG there runs its scripts with access to
// the CMS's storage, including the signed-in user's token, so download it.
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
function isLocalObjectUrl(href) {
  return /^(blob|data):/i.test(String(href));
}
const FileLink = /*#__PURE__*/_styled(({
  href,
  path
}) => _jsx("a", {
  href: href,
  rel: "noopener noreferrer",
  target: "_blank",
  download: isLocalObjectUrl(href) ? String(path).split('/').pop() : undefined,
  children: path
}), {
  target: "ecp3s3o0",
  label: "FileLink"
})(process.env.NODE_ENV === "production" ? {
  name: "4zleql",
  styles: "display:block"
} : {
  name: "4zleql",
  styles: "display:block/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
function FileLinkList({
  values,
  getAsset,
  field
}) {
  return _jsx("div", {
    children: values.map(value => _jsx(FileLink, {
      path: value,
      href: getAsset(value, field)
    }, value))
  });
}
function FileContent(props) {
  const {
    value,
    getAsset,
    field
  } = props;
  if (Array.isArray(value) || List.isList(value)) {
    return _jsx(FileLinkList, {
      values: value,
      getAsset: getAsset,
      field: field
    });
  }
  return _jsx(FileLink, {
    path: value,
    href: getAsset(value, field)
  }, value);
}
function FilePreview(props) {
  return _jsx(WidgetPreviewContainer, {
    children: props.value ? _jsx(FileContent, {
      ...props
    }) : null
  });
}
FilePreview.propTypes = {
  getAsset: PropTypes.func.isRequired,
  value: PropTypes.node
};
export default FilePreview;